import { expVal } from '@atlassian/jira-feature-experiments';

const timelineIncreaseIssueLinksLimitRelayProvider = {
	get(): number {
		return expVal('timeline_increase_issuelinks_limit', 'isEnabled', false) ? 20 : 10;
	},
};

export default timelineIncreaseIssueLinksLimitRelayProvider;
